import { render, staticRenderFns } from "./EDocumentsCategory.vue?vue&type=template&id=526d8a3e&"
import script from "./EDocumentsCategory.vue?vue&type=script&lang=js&"
export * from "./EDocumentsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports